export default "__VITE_ASSET__Cso405uj__"